
<div class="layout-wrapper layout-content-navbar">
        <div class="layout-container">

            <!-- Menu -->
            <app-main-sidebar></app-main-sidebar>
            <!-- /Menu -->

            <div class="layout-page">
                <!-- Navbar -->
              <app-main-header></app-main-header>
                <!-- /Navbar -->

                <!-- Content wrapper -->
                <div class="content-wrapper">

                    <router-outlet></router-outlet>
               
                </div>
                <!-- Content wrapper -->
            </div>


        </div>
        <!-- Overlay -->
        <div class="layout-overlay layout-menu-toggle"></div>
    </div>